import React, { useState, useEffect } from "react";
import Footer from "./footer";
import DashboardNavbar from "./DashboardNavbar";
import "../style.css";
import { getData } from "../api/protectedApi";
import ReactPaginate from "react-paginate";
import { useParams } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const LevelTeam = () => {
  const { level } = useParams();

  const [teamData, setTeamData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const perPage = 10;

  const getTeamList = async (page = 1) => {
    try {
      const res = await getData(
        `/self_level_details/${level}?per_page=${perPage}&page=${page}`
      );

      setTeamData(res.data.data);
      setTotalPages(Number(res.data.pagination.total_pages));
    } catch (err) {
      console.error("API Error", err);
    }
  };

  // initial load
  useEffect(() => {
    getTeamList(1);
  }, [level]);

  // pagination click
  const handlePageClick = (event) => {
    const selectedPage = event.selected; // 0-based
    setCurrentPage(selectedPage);
    getTeamList(selectedPage + 1); // backend expects 1-based
  };

  return (
    <>
        <div
          style={{
            backgroundColor: "#0d0e13",
            minHeight: "100vh",
            color: "#fff",
            padding: "12px 0",
          }}
        >
          <DashboardNavbar />

          <section>
            <div className="container">
              <div className="directs-wrapper">
                <div className="directs-title">Team View List</div>

                <div className="table-responsive">
                  <table className="table directs-table align-middle">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>User Id</th>
                        <th>Sponsor Id</th>
                        <th>Level</th>
                        <th>Package</th>
                        <th>Joining Time</th>
                      </tr>
                    </thead>

                    <tbody>
                      {teamData.length > 0 ? (
                        teamData.map((item, index) => (
                          <tr key={index}>
                            <td>{currentPage * perPage + index + 1}</td>
                            <td>{item.user_id}</td>
                            <td>{item.sponsor_id}</td>
                            <td>{item.level}</td>
                            <td>{item.package}</td>
                            <td>{item.date}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* ✅ REAL PAGINATION */}
                {totalPages > 1 && (
                  <ReactPaginate
                    previousLabel={<FaChevronLeft />}
                    nextLabel={<FaChevronRight />}
                    breakLabel="..."
                    pageCount={totalPages}
                    forcePage={currentPage}
                    onPageChange={handlePageClick}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={3}
                    containerClassName="pagination custom-pagination justify-content-center mt-4"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item disabled"
                    breakLinkClassName="page-link"
                    activeClassName="active"
                  />
                )}
              </div>
            </div>
          </section>
          <Footer />
        </div>
    </>
  );
};

export default LevelTeam;
